<template>
  <div class="bottom-bar">
    <div class="bottom-bar-spacer" />

    <div class="bottom-bar-main">
      <router-link :to="{name: 'home'}">
        <home-icon
          v-if="active === 'home'"
          decorative
        />
        <home-outline-icon
          v-else
          decorative
        />
        Home
      </router-link>

      <router-link
        :to="{ name: 'all_listings' }"
        :class="{ active: active === 'for_sale' }"
      >
        <tag-icon
          v-if="active === 'for_sale'"
          decorative
        />
        <tag-outline-icon
          v-else
          decorative
        />
        For Sale
      </router-link>

      <router-link
        v-if="userData"
        :to="{ name: 'notifications' }"
        :class="{ active: active === 'notifications' }"
      >
        <div class="notifications-bell-container">
          <notifications-bell :outline-icon="active !== 'notifications'" />
          <notification-badge />
        </div>
        Notifications
      </router-link>

      <router-link :to="{name: 'all_groups'}">
        <account-multiple-icon
          v-if="active === 'groups'"
          decorative
        />
        <account-multiple-outline-icon
          v-else
          decorative
        />
        Groups
      </router-link>

      <router-link :to="{name: 'more'}">
        <menu-icon decorative />
        More
      </router-link>
    </div>
  </div>
</template>

<script>
import NotificationBadge from '@virgodev/notifications/components/NotificationBadge.vue';

import NotificationsBell from '@/components/NotificationsBell.vue';

export default {
  name: 'BottomBar',
  components: {
    NotificationsBell,
    NotificationBadge,
  },
  computed: {
    active() {
      switch (this.$route.name) {
        case 'home':
          return 'home';
        case 'user_listings':
        case 'all_listings':
        case 'auctions':
        case 'listing_category':
          return 'for_sale';
        case 'notifications':
          return 'notifications';
        case 'more':
          return 'more';
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  .bottom-bar-spacer {
    height: var(--bottom-bar-height);
  }

  .bottom-bar-main {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    background-color: #fff;
    border-top: 0.5px solid var(--gray);
    text-align: center;
    z-index: 10;

    .dropdown-menu a {
      padding: 6px 16px;
      text-align: left;
      font-size: 1rem;
    }

    > a,
    .dropdown-menu-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      color: var(--blue-dark);
    }

    > a,
    /deep/ .dropdown-menu-content .btn {
      height: var(--bottom-bar-height);
      font-size: 80%;
      font-size: .65rem;
    }

    /deep/ .dropdown-menu-content .btn {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    /deep/ .material-design-icon {
      margin-bottom: 0.1rem;
      font-size: 1.5rem;
    }

    .router-link-exact-active,
    .active {
      color: var(--blue);
    }
  }

  .notifications-bell-container {
    margin: 0 auto;
    position: relative;
    line-height: 0;
  }

  @media (min-width: 1024px) {
    .bottom-bar {
      display: none;
    }
  }
</style>
